export enum CompanyPolicyVersionHistorySearchOptions {
    Version = 1,
    VersionNotes = 2
}

export enum CompanyPolicyVersionHistoryFilterOptions {
    None = 1,
    Deleted = 2
}
